import React from "react";
import PropTypes from "prop-types";
import CtasListItemOptions from "../ctas/CtasListItemOptions";
import CtasListItemStatus from "../ctas/CtasListItemStatus";
import CtaGroupsSmallList from "../cta_groups/CtaGroupsSmallList";
import { reportingGoals } from "../../src/reportingGoals";

const CtasListItemRow = (props) => {
  const websiteLink = "/websites/" + props.cta.website_id;
  const ctaLink = websiteLink + "/cta/" + props.cta.id;
  const goals = reportingGoals(props.website);

  const changeBadge = (change) => {
    const value = change == null ? null : Number(change);
    const label = value == null ? "—" : `${Math.abs(Math.round(value))}%`;
    const isZero = value == null || value === 0;
    const style = {
      display: "inline-flex",
      alignItems: "center",
      padding: "2px 8px",
      borderRadius: "999px",
      fontSize: "11px",
      fontWeight: 500,
      marginTop: "4px",
      background: isZero ? "#f3f4f6" : value > 0 ? "#dcfce7" : "#fee2e2",
      color: isZero ? "#374151" : value > 0 ? "#166534" : "#991b1b",
    };

    const arrow =
      value > 0 ? (
        <svg
          style={{
            width: "12px",
            height: "12px",
            marginRight: "4px",
            transform: "rotate(-45deg)",
          }}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ) : value < 0 ? (
        <svg
          style={{
            width: "12px",
            height: "12px",
            marginRight: "4px",
            transform: "rotate(45deg)",
          }}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ) : null;

    return (
      <span style={style}>
        {arrow}
        {label}
      </span>
    );
  };

  const metricClass = (wide) =>
    `ctas-list-row-column ctas-list-metric${
      wide ? " ctas-list-metric-wide" : ""
    }`;

  return (
    <div className="CtasListItemRow">
      <div className="ctas-list-name-column">
        <a href={ctaLink} className="ctas-list-preview-link">
          <div
            className="ctas-list-row-item-preview"
            style={{
              backgroundImage:
                "url(" +
                (props.variant && props.variant.screenshot
                  ? props.variant.screenshot
                  : "") +
                ")",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </a>
        <div className="ctas-list-name-text">
          <a href={ctaLink}>
            <p
              className="light ellipsis"
              data-toggle="tooltip"
              data-placement="top"
              title={props.cta.name}
              style={{
                textTransform: "capitalize",
                margin: "0",
                fontSize: "14px",
              }}
            >
              {props.cta.cta_type !== "inline"
                ? props.cta.cta_type
                : "Embedded"}{" "}
              - {props.cta.name}
            </p>
          </a>
          {props.hide_manage_groups ? (
            ""
          ) : (
            <CtaGroupsSmallList
              groups={props.cta.groups}
              trim={true}
              {...props}
            />
          )}
        </div>
      </div>
      <div className="ctas-list-metrics">
        <a href={ctaLink} className={metricClass(true)}>
          <p className="light ellipsis">{numberWithCommas(props.cta.views)}</p>
          {changeBadge(props.cta.views_change)}
        </a>
        <a href={ctaLink} className={metricClass(true)}>
          <p className="light ellipsis">
            {numberWithCommas(props.cta.conversions)} (
            {parseFloat(props.cta.conversion_rate).toFixed(0)}%)
          </p>
          {changeBadge(props.cta.conversions_change)}
        </a>
        <a href={ctaLink} className={metricClass(true)}>
          <p className="light ellipsis">
            {numberWithCommas(props.cta.completions)} (
            {parseFloat(props.cta.completion_rate).toFixed(0)}%)
          </p>
          {changeBadge(props.cta.completions_change)}
        </a>
        {goals.checkouts && (
          <a href={ctaLink} className={metricClass(false)}>
            <p className="light ellipsis">
              {numberWithCommas(props.cta.orders)}
            </p>
            {changeBadge(props.cta.orders_change)}
          </a>
        )}
        {goals.checkouts && (
          <a href={ctaLink} className={metricClass(false)}>
            <p className="light ellipsis">
              {props.currency}
              {numberWithCommas(props.cta.revenue)}
            </p>
            {changeBadge(props.cta.revenue_change)}
          </a>
        )}
        {goals.checkouts && (
          <a href={ctaLink} className={metricClass(false)}>
            <p className="light ellipsis">
              {props.currency}
              {numberWithCommas(props.cta.aov)}
            </p>
            {changeBadge(props.cta.aov_change)}
          </a>
        )}
        {goals.bookings && (
          <a href={ctaLink} className={metricClass(false)}>
            <p className="light ellipsis">
              {numberWithCommas(props.cta.bookings)}
            </p>
            {changeBadge(props.cta.bookings_change)}
          </a>
        )}
        {goals.custom && (
          <a href={ctaLink} className={metricClass(false)}>
            <p className="light ellipsis">
              {numberWithCommas(props.cta.custom_goals)}
            </p>
            {changeBadge(props.cta.custom_goals_change)}
          </a>
        )}
        <div className="ctas-list-row-column ctas-list-campaign-column">
          {props.hide_status == true ? "" : <CtasListItemStatus {...props} />}
        </div>
        <div className="ctas-list-row-column ctas-list-options-column sticky-options-col">
          {props.hide_options == true ? "" : <CtasListItemOptions {...props} />}
        </div>
      </div>
    </div>
  );
};

export default CtasListItemRow;
